import { render, staticRenderFns } from "./EntradaSalida.vue?vue&type=template&id=35f0841a&scoped=true"
import script from "./EntradaSalida.vue?vue&type=script&lang=ts"
export * from "./EntradaSalida.vue?vue&type=script&lang=ts"
import style0 from "./EntradaSalida.vue?vue&type=style&index=0&id=35f0841a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f0841a",
  null
  
)

export default component.exports